import script from "./multi-text-input.vue?vue&type=script&setup=true&lang=js"
export * from "./multi-text-input.vue?vue&type=script&setup=true&lang=js"

import "./multi-text-input.vue?vue&type=style&index=0&id=ce16e918&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce16e918"]])

export default __exports__